import React from "react";
import { Badge } from "@mantine/core";

export interface EventStatusBadgeProps {
  status?: number | undefined | null;
}

const statuses: any = {
  "-1": { label: "Unknown", color: "gray" },
  0: { label: "Disabled", color: "red" },
  50: { label: "Canceled", color: "orange" },
  100: { label: "Active", color: "green" },
};

export const EventStatusBadge: React.FC<EventStatusBadgeProps> = ({
  status,
}) => {
  const badgeInfo = statuses[status != null ? status : "-1"];

  return (
    <Badge color={badgeInfo.color} variant="light" size="sm">
      {badgeInfo.label}
    </Badge>
  );
};
